module.exports = __webpack_public_path__ + "static/img/face3a.80d7ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/face3a.png
// module id = VcSq
// module chunks = 1